import { render, staticRenderFns } from "./GvsExpTable.vue?vue&type=template&id=1af86fb4"
import script from "./GvsExpTable.vue?vue&type=script&lang=js"
export * from "./GvsExpTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports